import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ChangePasswordForm from '../components/ChangePasswordForm';

/**
 * Tela cheia de troca de senha usada APENAS no fluxo forçado (usuário logou
 * com senha temporária e `mustChangePassword=true`). O ProtectedRoute e o
 * RoleRoute redirecionam pra cá enquanto o flag estiver ativo.
 *
 * Troca voluntária: veja a aba "Segurança" dentro de /configuracoes.
 */
export default function ChangePassword() {
  const { me, logout } = useAuth();
  const navigate = useNavigate();

  const handleCancel = () => {
    // O usuário aqui está preso com senha provisória; a única saída sem
    // trocar é fazer logout e entrar com outra conta.
    logout();
    navigate('/login', { replace: true });
  };

  const handleDone = () => {
    navigate('/dashboard', { replace: true });
  };

  return (
    <div className="login-wrap">
      <div className="login-visual">
        <div className="brand">
          <div className="brand-mark">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="10" r="3" />
              <path d="M12 2a8 8 0 0 0-8 8c0 5.4 8 12 8 12s8-6.6 8-12a8 8 0 0 0-8-8z" />
            </svg>
          </div>
          <div className="brand-name">
            Otimiza<span>Rota</span>
          </div>
        </div>
        <div className="login-hero">
          <div className="login-eyebrow">
            <span className="dot" />
            Primeiro acesso
          </div>
          <h1 className="login-h1">
            Bem-vindo,<br />
            {me?.name?.split(' ')[0] || 'novo usuário'}.
          </h1>
          <p className="login-lede">
            Antes de continuar, defina uma senha pessoal. A senha temporária
            que você recebeu não pode ser usada para operar o sistema.
          </p>
        </div>
      </div>
      <div className="login-form-wrap">
        <div className="login-card">
          <h2>Criar sua senha</h2>
          <p className="sub">Você está logado como <strong>{me?.email}</strong></p>
          <ChangePasswordForm forced onDone={handleDone} onCancel={handleCancel} />
        </div>
      </div>
    </div>
  );
}
